import React, { Fragment, useState } from 'react'
import { Box, Heading, Text, useDisclosure } from '@ritualco/jutsu'
import { useContent } from '../../lib/content/react'
import { useHistory } from 'lib/router'
import { MerchantListCreateModal } from '../../components/Modals/MerchantListCreateModal'
import {
  CreateMerchantListRequest,
  MerchantList,
  MerchantListType,
} from '../../lib/generated/api'
import {
  useCreateMerchantList,
  useRestaurantListsQuery,
} from 'api/endpoints/merchantLists'
import { MyListsTable } from 'components/Tables/MyList'
import Loading from 'components/Loading'
import { INITIAL_ROWS_PER_PAGE } from 'config'

export type MyListsProps = {
  organizationId: string
  workspaceId: string
}

const MyLists = ({ workspaceId, organizationId }: MyListsProps) => {
  const { formatMessage } = useContent()
  const history = useHistory()
  const onListCreated = (merchantList: MerchantList) => {
    history.push(
      `/workspaces/${workspaceId}/restaurants/lists/${merchantList.merchantListId}`
    )
  }
  const mutation = useCreateMerchantList(onListCreated)
  const { isOpen, onClose, onOpen } = useDisclosure()
  const [rowsPerPage, setRowsPerPage] = useState<number>(INITIAL_ROWS_PER_PAGE)
  const [paginationTokenOption, setPaginationTokenOption] = useState({})
  const { data, isLoading } = useRestaurantListsQuery({
    organizationId,
    workspaceId,
    limit: rowsPerPage,
    ...paginationTokenOption,
  })

  const onCreateList = (values: { name: string }) => {
    const request: CreateMerchantListRequest = {
      organizationId,
      workspaceId,
      merchantList: { name: values.name, type: MerchantListType.UserDefined },
    }
    mutation.mutate(request)
  }

  if (isLoading) {
    return <Loading />
  }

  if (!data) {
    // TODO: handle error state
    return <span>Something went wrong!</span>
  }

  const {
    results: merchantLists,
    paginationToken,
    hasNextPage = false,
    hasPreviousPage = false,
  } = data

  return (
    <Fragment>
      <Box mb={17}>
        <Heading as="h3" size="lg" mb={3}>
          {formatMessage({
            id: 'pmportal.restaurantLists.listsSubtitle',
          })}
        </Heading>
        <Text fontSize="small" color="grayscale.secondary">
          {formatMessage({
            id: 'pmportal.restaurantLists.listsDescription',
          })}
        </Text>
      </Box>
      <MerchantListCreateModal
        onSubmit={onCreateList}
        isOpen={isOpen}
        onClose={onClose}
      />
      <MyListsTable
        onCreateNewList={onOpen}
        restaurantLists={merchantLists}
        hasNext={hasNextPage}
        hasPrev={hasPreviousPage}
        onPrev={() =>
          setPaginationTokenOption({ previousPageToken: paginationToken })
        }
        onNext={() =>
          setPaginationTokenOption({ nextPageToken: paginationToken })
        }
        onRowsPerPageChange={e => setRowsPerPage(Number(e.target.value))}
        rowsPerPage={rowsPerPage}
      />
    </Fragment>
  )
}

export default MyLists
